<template>
  <div>
    <div v-if="itemLocal">
      <div class="grid p-pt-2">
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Delivered by") }}:</span>
          <span class="item-data">{{ WorkerName }}</span>
        </div>
        <div class="p-d-flex p-flex-column">
          <span>{{ __("Date and time of collection") }}:</span>
          <span class="item-data">{{
            dateFormat(itemLocal.DateAndTimeDelivered, true)
          }}</span>
        </div>
      </div>
      <div class="p-d-flex p-flex-column p-pt-2">
        <span>{{ __("Recipient") }}:</span>
        <p-vue-input-text v-model="itemLocal.CollectingName" />
        <i-form-error :data="errors.CollectingName" />
      </div>
      <div class="p-d-flex p-flex-column p-pt-2">
        <span>{{ __("Comments") }}:</span>
        
        <p-vue-textarea
          rows="4"
          class="p-inputtext--alt no-radius"
          :autoResize="true"
          v-model="itemLocal.CommentDelivered"
        />
      </div>
    </div>
    <div class="p-d-flex p-jc-between p-mt-4">
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Save')"
        @click="save"
      />
      <p-vue-button
        class="button p-button-rounded p-button-success"
        :label="__('Cancel')"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import {
  errorReceived,
  showSuccessOrFailedModal,
  dateFormat,
} from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";

export default {
  props: {
    item: Object,
    close: Function,
  },
  emits: ["itemUpdate"],
  data() {
    return {
      itemLocal: {},
      errors: {},
      valid: true,
      dateFormat,
    };
  },
  mounted() {
    // console.log(this.item, this.WorkerName);
    if (this.item) this.itemLocal = this.item;
    this.itemLocal.DateAndTimeDelivered = new Date();
  },
  methods: {
    save() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("ID", this.itemLocal.ID, apiPType.Int),
        apiParam("CollectingName", this.itemLocal.CollectingName, apiPType.Int),
        apiParam("DateAndTimeDelivered", new Date(), apiPType.Int),
        apiParam("WorkerIDDelivered", this.workerID, apiPType.Int),
      ];
      callProc("WorkerApp_ItemDelivered", procParams)
        .then(() => {
          // result = JSON.parse(result);
          this.$store.dispatch("doLoading", false);
          showSuccessOrFailedModal(__(`Data saved successfully!`));
          // setTimeout(() => {
          //   this.$router.push({
          //     name: "Dashboard",
          //   });
          // }, 2000);
          this.close();
        })
        .catch((e) => {
          errorReceived("WorkerApp_ItemDelivered", e);
        });
    },
  },
  computed: {
    ...mapState({
      workerID: (state) => state.api.workerID,
      WorkerName: (state) => state.api.User.userName,
    }),
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}

.item-data {
  color: var(--color-accent);
}
</style>
